

<template>
    <div class="container">
        <div class="phone_box">
            <p class="title">给手机号<span>{{disposePhone}}</span>发送验证码，进行身份验证</p>
            <div>
                <van-field
                    v-model="code"
                    center
                    clearable
                    placeholder="请输入短信验证码"
                >
                    <template #button>
                        <span v-if="!ifCode" class="get_code" @click="getCode">获取验证码</span>
                        <span v-else>{{time}}s</span>
                        <!-- <van-button size="small" type="primary"></van-button> -->
                    </template>
                </van-field>
            </div>
        </div>
        
        <div class="footer">
            <van-button type="info" round color="#FFB14A" block @click="byebye">注销</van-button>
        </div>
    </div>
</template>
<script>
import { send,deregister,getBuyerMCipher } from "@/api/join";
// import { send,deregister,getBuyerMCipher } from "../../../api/join";
export default {
    name:'buyerLogout',
    data(){
        return{
            agreementData:'',
            code:'',
            ifCode:false,
            time:59,
            codeTimeOut:'',
            routerParams:''
        }
    },
    created(){
        this.routerParams = this.$route.query;
        
    },
    computed:{
        disposePhone(){
            const phoneNum = this.routerParams.phone;
            const disposeNum = phoneNum.substr(0,3) + '****' + phoneNum.substr(7);
            return disposeNum;
        }
    },
    methods:{
        async getCode(){
            const phone = this.routerParams.phone;
            const rCodeRes = await getBuyerMCipher({phone})
            if(rCodeRes.appStatus.errorCode != 0){
                return this.$toast(rCodeRes.appStatus.message);
            }
            const rCode = rCodeRes.content.code;
            const res = await send({
                phone,
                type:'0',
                rqSource:'22',
                templateType:'12',
                rCode:this.$md5(`Q4jfE@#!12urt34..qOphfss${rCode}`)
            })
            if(res.appStatus.errorCode != 0){
                return this.$toast(res.appStatus.message);
            }
            this.ifCode = true;
            this.codeTimeOut = setInterval(()=>{
                if(this.time == 1){
                    this.clearTime()
                }
                this.time --;
            },1000)
        },
        async byebye(){
            if(!this.code){
                return this.$toast('请输入验证码');
            }
            const res = await deregister({
                code:this.code
            })
            if(res.appStatus.errorCode != 0){
                return this.$toast(res.appStatus.message);
            }
            this.$toast('注销成功');
            this.clearTime()
            if(wx.miniProgram){
                wx.miniProgram.navigateBack({delta: 1})
                wx.miniProgram.postMessage({data:'foo'});
            }else if (this.$store.getters.ambientType == 1) {
                window.Android.unRegistAndLogout();
            } else if (this.$store.getters.ambientType == 2) {
                window.webkit.messageHandlers.unRegistAndLogout.postMessage("");
            }
        },
        clearTime(){
            if(!this.codeTimeOut) return
            clearInterval(this.codeTimeOut)
            this.ifCode = false;
            this.time = 59
        },
    },
    
    beforeDestroy(){
        this.clearTime()
    }
}
</script>
<style lang="scss" scoped>
    .container{
        padding: 0 20px;
        height: calc(100vh - 46px);
        padding: 0 10px;
        display: flex;
        flex-direction: column;
        .phone_box{
            height: 100%;
            flex: 1;
            display: flex;
            flex-direction: column;
            margin-top: 30px;
            font-size: 15px;
            // justify-content: center;
            .title{
                text-align: center;
                
                font-weight: bold;
                span{
                    color: #FFB14A;
                }
            }
            .get_code{
                color: #FFB14A;
            }
        }
        .footer{
            padding: 22px 0 20px 0;
            display: flex;
            flex-direction: column;
            align-items: center;
            /deep/.van-button{
                width: 345px;;
            }
        }
    }
</style>